export default __webpack_public_path__ + "static/media/3.a24314d7.png";